const TYPES = {
    METHOD: 'method',
    PROPERTY: 'property',
};
class Atom {
    constructor(inst, args) {
        this.inst = inst;
        this.args = args;
    }
}
class MethodCanvasAtom extends Atom {
    constructor(inst, args) {
        super(inst, args);
        this.type = TYPES.METHOD;
    }
    execute(context) {
        context[this.inst](...this.args);
    }
}
class PropertyCanvasAtom extends Atom {
    constructor(inst, args) {
        super(inst, args);
        this.type = TYPES.PROPERTY;
    }
    execute(context) {
        context[this.inst] = this.args[0];
    }
}
const atomOf = {
    [TYPES.METHOD]: MethodCanvasAtom,
    [TYPES.PROPERTY]: PropertyCanvasAtom,
};
class CanvasAtom {
    constructor(type, inst, args) {
        return new atomOf[type](inst, args);
    }
}
CanvasAtom.METHOD = TYPES.METHOD;
CanvasAtom.PROPERTY = TYPES.PROPERTY;
export default CanvasAtom;
